<template>
  <div class="mvp-card" v-if="mvp">
    <div class="title">MVP</div>
    <div class="info flex-center">
       <img class="avatar" :src="mvp.avatar" v-if="mvp && mvp.avatar" />
       <div class="content">
        <div class="name">{{ mvp.playerName }}</div>
        <div class="team-info flex-center">
          <img :src="mvp.teamBadge" v-if="mvp.teamBadge" />
          <div class="team-name">{{ mvp.teamName }}</div>
        </div>
        <div class="number" v-if="mvp.number"><span>#</span>{{ mvp.number }}</div>
       </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mvp: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
.mvp-card {
  background: #fff;
  margin-top: 12px;
  padding: 12px 16px;
  .title {
    font-size: 15px;
    font-weight: bold;
    color: #3D3D3D;
  }
  .info {
    margin-top: 12px;
    > * + * {
      margin-left: 12px;
    }
    .avatar {
      width: 59px;
      height: 71px;
    }
    .content {
      flex: 1;
      height: 71px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .name {
        font-size: 15px;
        color: #303133;
      }
      .team-info {
        color: #337ECC;
        font-size: 13px;
        .team-name {
          flex: 1;
        }
        img{
          width: 22px;
          height: 22px;
          border-radius: 5px;
          margin-right: 5px;
        }
      }
      .number {
        font-size: 15px;
        color: #303133;
        font-weight: bold;
        span {
          font-size: 11px;
          font-weight: 400;
          margin-right: 4px;
        }
      }
    }
  }
}
</style>
